import React from 'react'

import {
  PriceBoxStyled,
  PriceBoxTopStyled,
  PriceBoxTitleStyled,
  PriceBoxCostStyled,
  PriceBoxDescStyled,
  PriceBoxDataStyled,
  PriceBoxCtaStyled,
  PriceBoxCtaCaptionStyled
} from './styles'
import Button from './../../atoms/Button'
import CheckList from './../../atoms/CheckList'
import { PriceBoxProps } from './types'

const PriceBox: React.FC<PriceBoxProps> = ({ isSmall, data: { title, price, description, list, cta } }) => {
  return (
    <PriceBoxStyled>
      <PriceBoxTopStyled {...{ isSmall }}>
        <PriceBoxTitleStyled
          as="h3"
          sx={{
            variant: 'bodyMontserrat13',
            fontFamily: 'secondary'
          }}
        >
          {title}
        </PriceBoxTitleStyled>
        <PriceBoxCostStyled
          as="p"
          sx={{
            variant: 'bodyMontserrat19',
            fontWeight: 'bold'
          }}
        >
          {price}
        </PriceBoxCostStyled>
        <PriceBoxDescStyled
          as="p"
          sx={{
            variant: 'headingMontserrat4',
            fontWeight: 'bold'
          }}
        >
          {description}
        </PriceBoxDescStyled>

        {list && (
          <PriceBoxDataStyled>
            <CheckList {...{ list }} />
          </PriceBoxDataStyled>
        )}
      </PriceBoxTopStyled>
      {cta?.urlText && (
        <PriceBoxCtaStyled>
          <Button variant="withArrow" {...cta} />
        </PriceBoxCtaStyled>
      )}
    </PriceBoxStyled>
  )
}

export default PriceBox
